import { onAuthStateChanged } from "firebase/auth";
import { get, ref } from "firebase/database";
import React, { createContext, useContext, useEffect, useState } from "react";
import { auth, rtdb } from "../firebaseConfig";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [encryptionKey, setEncryptionKey] = useState(null);
	const [loading, setLoading] = useState(true);
	const [isAdmin, setIsAdmin] = useState(false);

	// Function to retrieve encryption key from RTDB
	const retrieveEncryptionKey = async (userId) => {
		try {
			const snapshot = await get(ref(rtdb, `encryption_keys/${userId}`));
			if (snapshot.exists()) {
				return snapshot.val().key;
			}
			return process.env.REACT_APP_ENCRYPTION_KEY;
		} catch (error) {
			console.error("Error retrieving encryption key:", error);
			return process.env.REACT_APP_ENCRYPTION_KEY;
		}
	};

	// Function to check if user is admin
	const checkAdminStatus = (email) => {
		const adminEmails = [
			'oseib@okbfoundation.org',
			'calvinsamueldonkor@gmail.com',
			'aniketdas001@gmail.com',
			'michaeltrang1@gmail.com'
		];
		return adminEmails.includes(email);
	};

	useEffect(() => {
		const unsubscribe = onAuthStateChanged(auth, async (user) => {
			if (user) {
				// When user signs in, try to get their existing encryption key
				let key = await retrieveEncryptionKey(user.uid);

				// If no key exists, generate and store a new one
				if (!key) {
					key = process.env.REACT_APP_ENCRYPTION_KEY;
				}

				// Check if user is admin
				const adminStatus = checkAdminStatus(user.email);
				setIsAdmin(adminStatus);

				setEncryptionKey(key);
				setUser(user);
			} else {
				setUser(null);
				setEncryptionKey(null);
				setIsAdmin(false);
			}
			setLoading(false);
		});
		return () => unsubscribe();
	}, []);

	return (
		<UserContext.Provider
			value={{ user, setUser, encryptionKey, setEncryptionKey, loading, isAdmin }}>
			{children}
		</UserContext.Provider>
	);
};

export const useUser = () => {
	const context = useContext(UserContext);
	if (context === undefined) {
		throw new Error("useUser must be used within a UserProvider");
	}
	return context;
};
